import PubsubHandler from "../pubsub/pubsub-event-handler";
import { logAddToListFail, logAddToList } from "../analytics";
const { translate, fetchTranslationFromPhrase } = require("../utils/translate");

const NAMESPACE_FAVOURITE = "FAVOURITE_CLIENT";

const events = {
  ADD_TO_FAVOURITES: "ADD_TO_FAVOURITES",
  ADD_TO_FAVOURITES_INITIATE: "ADD_TO_FAVOURITES_INITIATE",
  ADD_TO_FAVOURITES_SUCCESS: "ADD_TO_FAVOURITES_SUCCESS",
  ADD_TO_FAVOURITES_FAIL: "ADD_TO_FAVOURITES_FAIL",
};

const favouritePubsub = PubsubHandler(NAMESPACE_FAVOURITE);

const statusCodes = {
  LIST_FETCH_SUCCESS: "LIST_FETCH_SUCCESS",
  LIST_FETCH_FAIL: "LIST_FETCH_FAIL",
  LIST_ADD_SUCCESS: "LIST_ADD_SUCCESS",
  LIST_ADD_FAIL: "LIST_ADD_FAIL",
};

// REVAMP - TODO: This will be used later for multiple lists for logged in users
// const GENERIC_USER = 'G';
// const REGISTERED_USER = 'R';

const addProduct = async (
  listService,
  lists,
  session,
  productNumber,
  productType,
  quantity
) => {
  const basePayload = {
    session,
    productType,
    productNumber,
    quantity,
  };

  if (lists.length === 0) {
    const payload = Object.assign({}, basePayload, {
      // TODO: Change this to be dynamic when rolling out to more markets than France
      // This used to be handled in PhraseApp by the Range Presentation team
      listName: CONFIG.shoppingListDefaultName,
    });
    return listService.addToNewList(payload);
  }

  const payload = Object.assign({}, basePayload, { listId: lists[0].id });
  return listService.addToList(payload);
};

const onAddToList = (getSessionContext, listService) => async (event = {}) => {
  try {
    if (
      window.ikea &&
      window.ikea.favourites &&
      window.ikea.favourites.agentLoaded
    ) {
      // list-agent is handling the ADD_TO_FAVOURITES calls (temporary hack while the solutions coexists)
      return;
    }
    const { productNumber, productType, quantity = 1, productName } = event;
    await fetchTranslationFromPhrase();
    if (!productNumber || !productType) {
      const errorMessage = new Error("productNumber or productType is missing");
      logAddToListFail({ errorMessage });
      favouritePubsub.publish(
        events.ADD_TO_FAVOURITES_FAIL,
        Object.assign({ errorMessage }, event, { skipToast: true })
      );
      window?.ikea?.toast(
        translate('add_to_wishlist_failure_toast'),
        null,
        null
      )
      return;
    }
    favouritePubsub.publish(
      events.ADD_TO_FAVOURITES_INITIATE,
      Object.assign({}, event, { skipToast: true })
    );

      const session = await getSessionContext();
      if (session.error) {
        throw new Error("Error fetching session context");
      }

    const { status, bags: lists } = await listService.fetchLists(session);
    if (status !== statusCodes.LIST_FETCH_SUCCESS) {
      const errorMessage = "Error fetching lists";
      logAddToListFail(errorMessage);
      window?.ikea?.toast(
        translate('add_to_wishlist_failure_toast'),
        null,
        null
      )
      throw new Error(errorMessage);
    }

    const response = await addProduct(
      listService,
      lists,
      session,
      productNumber,
      productType,
      quantity
    );
    if (response.status !== statusCodes.LIST_ADD_SUCCESS) {
      const errorMessage = "Error adding to list";
      logAddToListFail(errorMessage);
      window?.ikea?.toast(
        translate('add_to_wishlist_failure_toast'),
        null,
        null
      )
      throw new Error(errorMessage);
    }
    logAddToList(event);
    favouritePubsub.publish(
      events.ADD_TO_FAVOURITES_SUCCESS,
      Object.assign({}, event, { skipToast: true })
    );
    window?.ikea?.toast(
      translate('add_to_wishlist_success_toast', {
        productName,
      }),
      { label: translate('show'), callbackOrHref: CONFIG.shoppinglistUrl },
      null
    )
  } catch (error) {
    favouritePubsub.publish(
      events.ADD_TO_FAVOURITES_FAIL,
      Object.assign(error, event, { skipToast: true })
    );
    window?.ikea?.toast(
      translate('add_to_wishlist_failure_toast'),
      null,
      null
    )
  }
};

const init = (sessionPromise, listService) => {
  favouritePubsub.subscribe(
    events.ADD_TO_FAVOURITES,
    onAddToList(sessionPromise, listService)
  );
};

export default init;
